export const DEFAULT_OPENAI_MODEL = 'gpt-4o-mini';